import type { Reward, RewardCategory } from '@/features/store/types/reward'
import { useOptimizedRecords } from '@/shared/hooks/useOptimizedQuery'

interface UseStoreStoreProps {
  categoryId?: number
}

export const useStoreStore = ({ categoryId }: UseStoreStoreProps = {}) => {
  const { records: rewardCategories } = useOptimizedRecords<RewardCategory>({
    path: '/user/reward_categories'
  })

  const { records: rewards, isSuccess } = useOptimizedRecords<Reward>({
    path: '/user/rewards',
    params: {
      q: {
        reward_category_id_eq: categoryId
      }
    },
    enabled: !!categoryId
  })

  return { rewardCategories, rewards, isSuccess }
}
